import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldAlert, LogOut, RefreshCw } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-6" data-testid="pending-approval-page">
      <BrandLogo size={56} fallbackChar="M" />
      <div className="mt-6 max-w-md w-full bg-white rounded-lg border border-slate-200 shadow-sm p-6 text-center">
        <div className="w-12 h-12 rounded-full bg-amber-100 text-amber-700 mx-auto flex items-center justify-center">
          <ShieldAlert className="w-6 h-6" />
        </div>
        <h2 className="font-heading text-xl font-bold mt-3 tracking-tight">Awaiting admin approval</h2>
        <p className="text-sm text-slate-600 mt-2">
          Hi <span className="font-semibold">{user?.name || user?.email}</span> — your Google sign-in
          was successful, but your access still needs to be approved by your CRM administrator.
        </p>
        <p className="text-xs text-slate-400 mt-3">
          Once your role is assigned you'll be able to access the CRM. Please check back shortly.
        </p>
        <div className="mt-6 flex flex-col gap-2">
          <Button
            onClick={() => window.location.reload()}
            className="bg-[#2E86C1] hover:bg-[#2471A3] text-white"
            data-testid="pending-refresh"
          >
            <RefreshCw className="w-4 h-4 mr-1" /> Check again
          </Button>
          <Button
            variant="outline"
            onClick={logout}
            className="border-slate-200"
            data-testid="pending-signout"
          >
            <LogOut className="w-4 h-4 mr-1" /> Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
